export default __webpack_public_path__ + "static/anti-allergy-badge-6fa9602f8c7d24719334a25f23a03e87.png";